import styled from '@emotion/styled';
import DelogueLogoName from 'img/delogue-logo-name.svg';
import { Image } from 'components';
import { Welcome } from './Welcome';
import { Box } from '@mui/material';

type CenterContainerProps = {
  children: React.ReactNode;
  welcomeText: React.ReactNode;
  size?: 'small' | 'large';
};

export const CenterContainer = ({
  children,
  welcomeText,
  size = 'small',
}: CenterContainerProps) => {
  return (
    <Container>
      <LogoContainer>
        <Image src={DelogueLogoName} alt="Delogue logo name" width="auto" />
      </LogoContainer>
      <MiddleContainer
        sx={{
          flexDirection: { md: 'row', xs: 'column-reverse' },
          maxWidth: { xs: '500px', md: '840px' },
        }}
      >
        <LoginContainer sx={{ width: { xs: '100%', md: '50%' } }}>{children}</LoginContainer>
        <Welcome size={size}>{welcomeText}</Welcome>
      </MiddleContainer>
      <Footer />
    </Container>
  );
};

const Container = styled.main`
  display: flex;
  padding-inline: 24px;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-color: ${p => p.theme.palette.bg.secondary};
  gap: 24px;
  > div {
    flex-shrink: 0;
  }
  form {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

const LogoContainer = styled.div`
  margin-top: 36px;
`;

const MiddleContainer = styled(Box)`
  width: 100%;
  background-color: ${p => p.theme.palette.fg.white};
  display: flex;
  flex-direction: row;
  border-radius: 16px;
  border: ${p => `0.5px solid ${p.theme.palette.border.primarySubtle}`};
  box-shadow: 4px 8px 16px 0px rgba(34, 34, 34, 0.16);
  overflow: hidden;
`;

const LoginContainer = styled(Box)`
  display: flex;
  flex-direction: column;
`;

const Footer = styled.div``;
